import Backbone from 'backbone'
import icon from 'scoreboard/components/icon'
import Tooltip from 'scoreboard/components/tooltip'

/**
 * Renders warning icon with a tooltip on hover explaining that an initiative is
 * projected to have been completed in the past, but does not have a status update
 * to actually complete it. See #17787 and ticket:18700
 */
const ScheduleWarning = Backbone.View.extend({
	tagName: 'span',

	events: {
		'click .icon-warn': 'showTooltip',
		'mouseover .icon-warn': 'showTooltip',
		'mouseout .icon-warn': 'removeTooltip'
	},

	render() {
		this.$el.append(icon('warn', 'icon-warn'))

		this.$el.toggleClass('is-not-displayed', !this.showing())

		return this
	},

	/**
	 * Returns true if the warning icon should be showing. If there is a recent
	 * enough status update that the warning isn't necessary, it will return false
	 */
	showing() {
		return !!this.model.scheduleWarning()
	},

	showTooltip: function() {
		this.warningTooltip = new Tooltip({
			extraClass: 'schedule-warning-tooltip',
			attachTo: this.$('.icon-warn'),
			content: this.warningMessage()
		}).render()
	},

	warningMessage() {
		return this.model.scheduleWarning()
	},

	removeTooltip: function() {
		this.warningTooltip && this.warningTooltip.remove()
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeTooltip()
	}
})

function warningMessage (initiative, referenceDate) {
	return null
}

export default ScheduleWarning
export { warningMessage }

ScheduleWarning.__filename__ = 'initiatives/schedule-warning.js'
